import React, { useContext, useMemo } from 'react';
import { Alert, Col, Row } from 'react-bootstrap';
import { Link, Redirect, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import BSButton from '../../form/BSButton';
import AppointmentCard from './AppointmentCard';
import { DataTypeContext } from '../../DataTypes';

const ModifyAppointment = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const { isDeliveryEnabled } = useContext(DataTypeContext);

    const existingAppointment = location?.state?.existingAppointment;

    const bookingPath = useMemo(() => {
        if (isDeliveryEnabled && existingAppointment?.vromo_integration) {
            return '/book-delivery';
        }

        return '/book-appointment';
    }, [existingAppointment, isDeliveryEnabled]);

    if (!existingAppointment) {
        return <Redirect to={{ pathname: '/upcoming-appointments' }} />;
    }

    return (
        <Row className="justify-content-center my-4 my-md-5">
            <Col md={6} sm={12}>
                <div className="card shadow-sm rounded p-4">
                    <h4 className="text-center mb-4">{t('appointment.modifyHeading')}</h4>

                    <AppointmentCard appointment={existingAppointment} variant="summary" />

                    <p className="text-muted mb-4">
                        {t('appointment.modifyDescription')}
                    </p>

                    <BSButton
                        variant="primary"
                        className="w-100 mb-3"
                        onClick={() => history.push({ pathname: bookingPath, state: { existingAppointment } })}
                    >
                        {t('appointment.findNewTime')}
                    </BSButton>

                    <BSButton
                        variant="outline-secondary"
                        className="w-100 mb-4"
                        onClick={() => history.push('/upcoming-appointments')}
                    >
                        {t('appointment.keepCurrentAppointment')}
                    </BSButton>

                    <Alert variant="warning" className="mb-0">
                        <strong>{t('appointment.modifyCancelNoteLabel')}</strong> {t('appointment.modifyCancelNoteText')}
                    </Alert>
                </div>

                <p className="text-center mt-3 mb-0">
                    <Link to="/dashboard">{t('dashboard.return')}</Link>
                </p>
            </Col>
        </Row>
    );
};

export default ModifyAppointment;
